// useLoad.mjs — the ONE data-fetch effect (SB-042). Every list page used to
// hand-roll the same effect with an `alive` unmount guard — except two pages
// which FORGOT the guard (a late response after unmount warns and can clobber
// a newer route's state). One hook, guard always on.
//
//   const { status, data, error, reload } = useLoad(loader, [dep1, dep2]);
//     status: 'loading' | 'ready' | 'error'
//     loader: async () => data     (re-runs when deps change or reload() is called)
//     error:  the raw thrown value (map to a message at render via errKey)
//
// Deliberately tiny: no caching, no races beyond last-write-wins per dep-set —
// matching exactly what the hand-rolled effects did.
import { useEffect, useState } from 'react';

export function useLoad(loader, deps) {
  const [state, setState] = useState({ status: 'loading', data: null, error: null });
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, status: 'loading' }));
    loader().then(
      (data) => { if (alive) setState({ status: 'ready', data, error: null }); },
      (error) => { if (alive) setState({ status: 'error', data: null, error }); },
    );
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, nonce]);

  return { ...state, reload: () => setNonce((n) => n + 1) };
}
